import React from 'react';
import { useConfig } from '@hummingbirdtechgroup/wings-config';
import { logoutRedirect } from '../utils';
function LogoutRedirect({ redirectPath }) {
    const config = useConfig();
    logoutRedirect(config.accountsUrl, redirectPath);
    return React.createElement(React.Fragment, null, "Redirecting to login screen...");
}
export default LogoutRedirect;
//# sourceMappingURL=LogoutRedirect.js.map